var _path, _mask, _ellipse, _path2, _mask2, _ellipse2, _path3, _mask3, _ellipse3, _path4, _mask4, _ellipse4, _path5, _mask5, _ellipse5, _path6, _mask6, _ellipse6, _path7, _mask7, _ellipse7, _path8, _mask8, _ellipse8, _path9, _mask9, _ellipse9, _path10, _mask10, _ellipse10, _path11, _mask11, _ellipse11, _path12, _mask12, _ellipse12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78571 11.6934H1.5V28H5.78571M5.78571 11.6934V6.3688H8.07182M5.78571 11.6934V28M21.8571 28H26.5V11.0278H21.8571M21.8571 28V11.0278M21.8571 28H18.2857M21.8571 11.0278V6.3688H19.7143M19.7143 6.3688C19.7143 6.3688 19.7143 6.3688 19.7143 3.04093C19.7143 2.12918 18.2857 1.14377 17.2143 1.04423C16.5213 0.979846 12.9002 0.998774 10.4286 1.02018C9.07879 1.03187 8.21508 2.04264 8.07182 2.70822C7.92857 3.37379 8.07182 6.3688 8.07182 6.3688M19.7143 6.3688H8.07182M5.78571 28H10.0714M18.2857 28V23.341H14.1786M18.2857 28H14.1786M10.0714 28V23.341H14.1786M10.0714 28H14.1786M14.1786 28V23.341",
    stroke: "black",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 9.69673,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 9.69673,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 9.69673C9.14286 9.01284 9.69398 8.69509 10.0714 8.69509V12.6951C11.6323 12.6951 13.1429 11.4834 13.1429 9.69673H9.14286ZM10.0714 8.69509C10.4489 8.69509 11 9.01284 11 9.69673H7C7 11.4834 8.51052 12.6951 10.0714 12.6951V8.69509ZM11 9.69673C11 10.3806 10.4489 10.6984 10.0714 10.6984V6.69836C8.51052 6.69836 7 7.91008 7 9.69673H11ZM10.0714 10.6984C9.69398 10.6984 9.14286 10.3806 9.14286 9.69673H13.1429C13.1429 7.91008 11.6323 6.69836 10.0714 6.69836V10.6984Z",
    fill: "black",
    mask: "url(#path-2-inside-1_907_466)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 9.69673,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 9.69673,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0714 9.69673C13.0714 9.01284 13.6226 8.69509 14 8.69509V12.6951C15.5609 12.6951 17.0714 11.4834 17.0714 9.69673H13.0714ZM14 8.69509C14.3775 8.69509 14.9286 9.01284 14.9286 9.69673H10.9286C10.9286 11.4834 12.4391 12.6951 14 12.6951V8.69509ZM14.9286 9.69673C14.9286 10.3806 14.3775 10.6984 14 10.6984V6.69836C12.4391 6.69836 10.9286 7.91008 10.9286 9.69673H14.9286ZM14 10.6984C13.6226 10.6984 13.0714 10.3806 13.0714 9.69673H17.0714C17.0714 7.91008 15.5609 6.69836 14 6.69836V10.6984Z",
    fill: "black",
    mask: "url(#path-4-inside-2_907_466)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9286,
    cy: 9.69673,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9286,
    cy: 9.69673,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.69673C17 9.01284 17.5512 8.69509 17.9286 8.69509V12.6951C19.4895 12.6951 21 11.4834 21 9.69673H17ZM17.9286 8.69509C18.3061 8.69509 18.8572 9.01284 18.8572 9.69673H14.8572C14.8572 11.4834 16.3677 12.6951 17.9286 12.6951V8.69509ZM18.8572 9.69673C18.8572 10.3806 18.3061 10.6984 17.9286 10.6984V6.69836C16.3677 6.69836 14.8572 7.91008 14.8572 9.69673H18.8572ZM17.9286 10.6984C17.5512 10.6984 17 10.3806 17 9.69673H21C21 7.91008 19.4895 6.69836 17.9286 6.69836V10.6984Z",
    fill: "black",
    mask: "url(#path-6-inside-3_907_466)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 16.6849,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 16.6849,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 16.6849C9.14286 16.001 9.69398 15.6833 10.0714 15.6833V19.6833C11.6323 19.6833 13.1429 18.4715 13.1429 16.6849H9.14286ZM10.0714 15.6833C10.4489 15.6833 11 16.001 11 16.6849H7C7 18.4715 8.51052 19.6833 10.0714 19.6833V15.6833ZM11 16.6849C11 17.3688 10.4489 17.6865 10.0714 17.6865V13.6865C8.51052 13.6865 7 14.8982 7 16.6849H11ZM10.0714 17.6865C9.69398 17.6865 9.14286 17.3688 9.14286 16.6849H13.1429C13.1429 14.8982 11.6323 13.6865 10.0714 13.6865V17.6865Z",
    fill: "black",
    mask: "url(#path-8-inside-4_907_466)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-5_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0001,
    cy: 16.6849,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.0001,
    cy: 16.6849,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0716 16.6849C13.0716 16.001 13.6227 15.6833 14.0001 15.6833V19.6833C15.5611 19.6833 17.0716 18.4715 17.0716 16.6849H13.0716ZM14.0001 15.6833C14.3776 15.6833 14.9287 16.001 14.9287 16.6849H10.9287C10.9287 18.4715 12.4392 19.6833 14.0001 19.6833V15.6833ZM14.9287 16.6849C14.9287 17.3688 14.3776 17.6865 14.0001 17.6865V13.6865C12.4392 13.6865 10.9287 14.8982 10.9287 16.6849H14.9287ZM14.0001 17.6865C13.6227 17.6865 13.0716 17.3688 13.0716 16.6849H17.0716C17.0716 14.8982 15.5611 13.6865 14.0001 13.6865V17.6865Z",
    fill: "black",
    mask: "url(#path-10-inside-5_907_466)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-6_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9284,
    cy: 16.6849,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9284,
    cy: 16.6849,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 16.6849C16.9998 16.001 17.5509 15.6833 17.9284 15.6833V19.6833C19.4893 19.6833 20.9998 18.4715 20.9998 16.6849H16.9998ZM17.9284 15.6833C18.3058 15.6833 18.8569 16.001 18.8569 16.6849H14.8569C14.8569 18.4715 16.3675 19.6833 17.9284 19.6833V15.6833ZM18.8569 16.6849C18.8569 17.3688 18.3058 17.6865 17.9284 17.6865V13.6865C16.3675 13.6865 14.8569 14.8982 14.8569 16.6849H18.8569ZM17.9284 17.6865C17.5509 17.6865 16.9998 17.3688 16.9998 16.6849H20.9998C20.9998 14.8982 19.4893 13.6865 17.9284 13.6865V17.6865Z",
    fill: "black",
    mask: "url(#path-12-inside-6_907_466)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-7_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 13.0246,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 13.0246,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 13.0246C9.14286 12.3407 9.69398 12.023 10.0714 12.023V16.023C11.6323 16.023 13.1429 14.8113 13.1429 13.0246H9.14286ZM10.0714 12.023C10.4489 12.023 11 12.3407 11 13.0246H7C7 14.8113 8.51052 16.023 10.0714 16.023V12.023ZM11 13.0246C11 13.7085 10.4489 14.0262 10.0714 14.0262V10.0262C8.51052 10.0262 7 11.238 7 13.0246H11ZM10.0714 14.0262C9.69398 14.0262 9.14286 13.7085 9.14286 13.0246H13.1429C13.1429 11.238 11.6323 10.0262 10.0714 10.0262V14.0262Z",
    fill: "black",
    mask: "url(#path-14-inside-7_907_466)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-8_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 13.0246,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 13.0246,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0714 13.0246C13.0714 12.3407 13.6226 12.023 14 12.023V16.023C15.5609 16.023 17.0714 14.8113 17.0714 13.0246H13.0714ZM14 12.023C14.3775 12.023 14.9286 12.3407 14.9286 13.0246H10.9286C10.9286 14.8113 12.4391 16.023 14 16.023V12.023ZM14.9286 13.0246C14.9286 13.7085 14.3775 14.0262 14 14.0262V10.0262C12.4391 10.0262 10.9286 11.238 10.9286 13.0246H14.9286ZM14 14.0262C13.6226 14.0262 13.0714 13.7085 13.0714 13.0246H17.0714C17.0714 11.238 15.5609 10.0262 14 10.0262V14.0262Z",
    fill: "black",
    mask: "url(#path-16-inside-8_907_466)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-9_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9286,
    cy: 13.0246,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9286,
    cy: 13.0246,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.0246C17 12.3407 17.5512 12.023 17.9286 12.023V16.023C19.4895 16.023 21 14.8113 21 13.0246H17ZM17.9286 12.023C18.3061 12.023 18.8572 12.3407 18.8572 13.0246H14.8572C14.8572 14.8113 16.3677 16.023 17.9286 16.023V12.023ZM18.8572 13.0246C18.8572 13.7085 18.3061 14.0262 17.9286 14.0262V10.0262C16.3677 10.0262 14.8572 11.238 14.8572 13.0246H18.8572ZM17.9286 14.0262C17.5512 14.0262 17 13.7085 17 13.0246H21C21 11.238 19.4895 10.0262 17.9286 10.0262V14.0262Z",
    fill: "black",
    mask: "url(#path-18-inside-9_907_466)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-10_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 20.0131,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0714,
    cy: 20.0131,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.14286 20.0131C9.14286 19.3292 9.69398 19.0115 10.0714 19.0115V23.0115C11.6323 23.0115 13.1429 21.7998 13.1429 20.0131H9.14286ZM10.0714 19.0115C10.4489 19.0115 11 19.3292 11 20.0131H7C7 21.7998 8.51052 23.0115 10.0714 23.0115V19.0115ZM11 20.0131C11 20.697 10.4489 21.0148 10.0714 21.0148V17.0148C8.51052 17.0148 7 18.2265 7 20.0131H11ZM10.0714 21.0148C9.69398 21.0148 9.14286 20.697 9.14286 20.0131H13.1429C13.1429 18.2265 11.6323 17.0148 10.0714 17.0148V21.0148Z",
    fill: "black",
    mask: "url(#path-20-inside-10_907_466)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-11_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 20.0131,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 20.0131,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0714 20.0131C13.0714 19.3292 13.6226 19.0115 14 19.0115V23.0115C15.5609 23.0115 17.0714 21.7998 17.0714 20.0131H13.0714ZM14 19.0115C14.3775 19.0115 14.9286 19.3292 14.9286 20.0131H10.9286C10.9286 21.7998 12.4391 23.0115 14 23.0115V19.0115ZM14.9286 20.0131C14.9286 20.697 14.3775 21.0148 14 21.0148V17.0148C12.4391 17.0148 10.9286 18.2265 10.9286 20.0131H14.9286ZM14 21.0148C13.6226 21.0148 13.0714 20.697 13.0714 20.0131H17.0714C17.0714 18.2265 15.5609 17.0148 14 17.0148V21.0148Z",
    fill: "black",
    mask: "url(#path-22-inside-11_907_466)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-12_907_466",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9286,
    cy: 20.0131,
    rx: 1.07143,
    ry: 0.998363
  }))), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.9286,
    cy: 20.0131,
    rx: 1.07143,
    ry: 0.998363,
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.0131C17 19.3292 17.5512 19.0115 17.9286 19.0115V23.0115C19.4895 23.0115 21 21.7998 21 20.0131H17ZM17.9286 19.0115C18.3061 19.0115 18.8572 19.3292 18.8572 20.0131H14.8572C14.8572 21.7998 16.3677 23.0115 17.9286 23.0115V19.0115ZM18.8572 20.0131C18.8572 20.697 18.3061 21.0148 17.9286 21.0148V17.0148C16.3677 17.0148 14.8572 18.2265 14.8572 20.0131H18.8572ZM17.9286 21.0148C17.5512 21.0148 17 20.697 17 20.0131H21C21 18.2265 19.4895 17.0148 17.9286 17.0148V21.0148Z",
    fill: "black",
    mask: "url(#path-24-inside-12_907_466)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/hotels.8aed1733bbc424b87052d3b1d8c9b175.svg";
export { ForwardRef as ReactComponent };